export default __webpack_public_path__ + "img/f6dc877c098e9f28e9fca87f85dba46d.svg";